const POST_NETWORK_USAGE_EVENT_NAME = 'POST_NETWORK_USAGE_EVENT_NAME_1_0';

export { POST_NETWORK_USAGE_EVENT_NAME };
